export default __webpack_public_path__ + "4fd23946ad510c5014e0da5f34331e05.svg";